<template>
	<div class="reason" :class="{ 'ac-bg-black': ac }">
		<header-component
			:is-soon="false"
			img-left="/trocachip/img/setinha-left-preto.svg"
			img-right="/trocachip/img/access.png"
			class="header-component"
		/>
		<div
			:class="{ 'background-desktop-black': ac, 'background-desktop': !ac }"
		></div>
		<div class="container">
			<h2 class="reason_title" :class="{ 'ac-color-white': ac }">
				Escolha o motivo<br />
				da sua troca de chip?
			</h2>
			<div class="reason_container-button">
				<button
					class="reason_button"
					@click.prevent="next(ReasonEnum.TECHNOLOGY_UPDATE)"
					:class="{ 'ac-border-yellow': ac, 'ac-color-yellow': ac }"
				>
					Mudança de 3G para 4G
				</button>
				<button
					class="reason_button"
					@click.prevent="next(ReasonEnum.LOSS_OR_THEFT)"
					:class="{ 'ac-border-yellow': ac, 'ac-color-yellow': ac }"
				>
					Roubo ou perda do chip
				</button>
				<button
					class="reason_button"
					@click.prevent="next(ReasonEnum.DEFECT)"
					:class="{ 'ac-border-yellow': ac, 'ac-color-yellow': ac }"
				>
					Chip com defeito
				</button>
			</div>
		</div>
		<alert
			:description="alert.info"
			danger="true"
			:message="alert.description"
			v-on:close="alertUpdateTecnology = !alertUpdateTecnology"
			v-if="alertUpdateTecnology"
		/>
	</div>
</template>

<script>
import { ReasonEnum, ReasonLabelConfigEnum, ReasonLabelName } from '@/core/reason';
import HeaderComponent from '../components/HeaderComponent';
import trackEvent from '../services/trackEvent';
import Alert from '../components/Alert';
import { mapState } from 'vuex';

export default {
	name: 'Reasons',
	components: {
		HeaderComponent,
		Alert,
	},
	data() {
		return {
			ReasonEnum,
			alertUpdateTecnology: false,
			alert: { info: '', description: '' },
		};
	},
	computed: mapState({
		ac: (state) => state.ac,
		document: (state) => state.document,
		config: (state) => state.config,
		customer: (state) => state.customer,
		initFlow: (state) => state.config['init_flow'],
	}),
	created() {
		const config = this.config.reason;
		this.alert.info = this.isExOi()
			? config.clientExOi.info
			: config.default.info;
		this.alert.description = this.isExOi()
			? config.clientExOi.description
			: config.default.description;
	},
	methods: {
		checkEnriched() {
			return this.customer.enriched === '';
		},
		notUpdateTecnology() {
			if (this.isExOi()) {
			return (this.alertUpdateTecnology = true);
			} else {
				this.$router.push({ name: 'wifi-error' });
			}
		},
		async next(reason) {
			const reasonLabel = this.config[ReasonLabelConfigEnum[reason]];
			const reasonLabelName = ReasonLabelName[reason];
			await this.trackEvent(reasonLabelName);
			await this.$store.dispatch('reason', reasonLabel);

			switch (reason) {
				case ReasonEnum.TECHNOLOGY_UPDATE:
					if (this.customer.enriched != 2) return this.notUpdateTecnology();
					this.$router.push({ name: 'documents' });
					break;
				case ReasonEnum.LOSS_OR_THEFT:
				case ReasonEnum.DEFECT:
					this.$router.push({ name: 'information-check' });
					break;
				default:
					throw new Error('Invalid reason.');
			}
		},
		trackEvent(reason) {
			trackEvent.track({
				user: {
					login: this.customer.login,
					loginType: '',
					lineType: this.customer.loginType,
					segment: this.customer.segment,
					subSegment: this.customer.subSegment,
					planCode: this.customer.planCode,
					planName: this.customer.planName,
				},
				channel: trackEvent.getChannel(),
				'event-category': 6,
				'event-label': reason,
				'event-value': null,
				'event-status': 'Sucesso',
				'event-interactionNumber': '',
				'event-error': '',
				'event-errorDetail': '',
			});
		},
		isExOi() {
			return this.customer.isExOiCustomer;
		},
	},
};
</script>

<style lang="scss">
.reason {
	width: 100%;
	height: 100%;
	display: block;
	position: absolute;
	.background-desktop {
		display: none;
	}
	.reason_title {
		width: 100%;
		height: auto;
		font-family: 'timsans_regular';
		display: block;
		margin-top: 96px;
		font-size: 1.688em;
		font-weight: 300;
		line-height: 1.11;
		text-align: center;
		color: #000000;
	}
	.reason_container-button {
		width: 100%;
		height: auto;
		margin-top: 72px;
		display: block;
		display: grid;
		align-items: center;
		.reason_button {
			width: 253px;
			height: 52px;
			margin: 0 auto 24px auto;
			border-radius: 26px;
			border: solid 1px #003091;
			background: none;
			outline: none;
			font-size: 1em;
			text-align: center;
			color: #003091;
			&:hover {
				cursor: pointer;
				-webkit-box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
				-moz-box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
				box-shadow: 0px 0px 5px 0px rgba(100, 100, 100, 0.5);
				transition: 1s;
			}
		}
	}
}
@media (min-width: 768px) {
	.reason {
		width: 100%;
		height: 100%;
		display: grid;
		grid-auto-columns: 50% 50%;
		grid-template-areas:
			'header header'
			'container background';
		position: absolute;
		.header-component {
			width: 45%;
			grid-area: header;
		}
		.background-desktop {
			grid-area: background;
			width: 100%;
			height: 100vh;
			display: block;
			background: url('../assets/images/desktop@2x.jpg') no-repeat;
			background-size: 240% 100vh;
			background-position-x: -20px;
		}
		.background-desktop-black {
			grid-area: background;
			width: 100%;
			height: 100vh;
			display: block;
			background: url('../assets/images/desktop-black.png') no-repeat;
			background-size: 240% 100vh;
			background-position-x: -20px;
		}
		.container {
			grid-area: container;
			.reason_title {
				width: 416px;
				height: auto;
				display: block;
				margin: 115px auto 0 auto;
				font-family: 'timsans_thin';
				font-size: 2em;
				font-weight: normal;
				line-height: 1.2;
			}
			.reason_container-button {
				width: 100%;
				height: auto;
				margin-top: 72px;
				display: block;
				display: grid;
				align-items: center;
				.reason_button {
					width: 320px;
					height: 52px;
					margin: 0 auto 32px auto;
					border-radius: 26px;
					font-size: 1em;
				}
			}
		}
	}
}
@media (min-width: 960px) {
	.reason {
		width: 100%;
		height: 100%;
		display: grid;
		grid-auto-columns: 50% 50%;
		grid-template-areas:
			'header header'
			'container background';
		position: absolute;
		.header-component {
			width: 45%;
			grid-area: header;
		}
		.background-desktop {
			grid-area: background;
			width: 100%;
			height: 100vh;
			display: block;
			background: url('../assets/images/desktop@3x.png') no-repeat;
			background-size: cover;
			background-position-x: 0;
		}
		.background-desktop-black {
			grid-area: background;
			width: 100%;
			height: 100vh;
			display: block;
			background: url('../assets/images/desktop-black.png') no-repeat;
			background-size: cover;
			background-position-x: 0;
		}
		.container {
			grid-area: container;
			.reason_title {
				width: 416px;
				height: auto;
				display: block;
				margin: 115px auto 0 auto;
				font-family: 'timsans_thin';
				font-size: 2em;
				font-weight: normal;
				line-height: 1.2;
			}
			.reason_container-button {
				width: 100%;
				height: auto;
				margin-top: 72px;
				display: block;
				display: grid;
				align-items: center;
				.reason_button {
					width: 320px;
					height: 52px;
					margin: 0 auto 32px auto;
					border-radius: 26px;
					font-size: 1em;
				}
			}
		}
	}
}
</style>
